// 身份证号码加密
export function maskIdCard(idCard){
    if (idCard.length === 18) { // 确保身份证号码的长度是18位
        const front = idCard.slice(0, 4); // 前四位
        const back = idCard.slice(-4); // 后四位
        const masked = front + '**** **** ' + back;
        console.log('masked',masked);
        return masked;
    }
    return '无效身份证号码';
  }